if (typeof p80 === typeof undefined) {
  var p80 = {};
}

p80.productHistory = function (config) {
  /****
   *
   * USAGE:
   *
   * Update line 55 with your unique store front access token (unless it has already been defined by the theme in p80.storefrontToken)
   *
   * const p80History = new p80.productHistory(
   *  {
   *      resultsDisplayed: 4,
   *      targetElement: "your-target-identifier",
   *      title: "Recently Viewed Products",
   *      productId: {current product ID}
   *  }
   * );
   *
   * REFRESH LIVE:
   *
   * p80History.getHistory();
   *
   */

  /****
   *
   * CONFIGURATION
   *
   * {
   *      resultsDisplayed: int || 4,
   *      targetElement: string || "product-history",
   *      title: string || "Recently Viewed Products",
   *      productId: int || null,
   * }
   *
   */
  this.config = {};
  // Maximum number of recently viewed products stored
  // By default this should be one larger than our displayed results - in case our history includes the product we are viewing
  this.config.resultsStored = 5;
  // Maxmium number of recently viewed products displayed
  this.config.resultsDisplayed = config && config.resultsDisplayed ? config.resultsDisplayed : 4;
  // String that holds the title for our recently viewed product area
  (this.config.title = config && config.title ? config.title : 'Recently Viewed Products'),
    // The string identifier for the element we will look to append our markup to
    (this.config.targetElement = config && config.targetElement ? config.targetElement : 'product-history');
  // The product ID of the current product, used to add to our history stack
  this.config.productId = config && config.productId ? config.productId : null;
  // Name of the cookie where we store our viewed history
  this.config.cookieName = 'p80ProductHistory';
  // Our unique store front access token
  this.config.storefrontToken = null;
  if (p80.storefrontToken) {
    this.config.storefrontToken = p80.storefrontToken;
  } else if (config && config.storefrontToken) {
    this.config.storefrontToken = config.storefrontToken;
  }

  /****
   *
   * Data
   *
   */

  // Holds our product history
  this.productHistory = null;
  // Holds our markup
  this.html = null;
  // Fetch our product history and generate Results
  // Track our product view AFTER history has been fetched - we don't want to show the product the user is currently viewing
  if (!this.config.productId || this.config.productId === '') {
    this.getHistory();
  } else {
    this.addProductView();
  }
};
// Fetch our history data cookie
p80.productHistory.prototype.getHistory = function () {
  let history = this;
  const cookies = document.cookie;
  let cookie = cookies.match(new RegExp('(^| )' + history.config.cookieName + '=([^;]+)'));

  // If we don't have any history data we don't bother generating
  if (!cookie || cookie.length < 1) {
    return;
  }

  cookie = cookie[2];
  cookie = JSON.parse(cookie);

  // Check if our currently viewed product is in our recently viewed list and remove it - we don't want to display the product we're looking at
  const cookieKey = cookie.indexOf(history.config.productId);
  if (cookieKey > -1) {
    cookie.splice(cookieKey, 1);
  }

  // Generate our graphql query to get each variant's information
  let productIds = '';
  for (let i = 0; i < cookie.length; i++) {
    productIds += `"gid://shopify/Product/${cookie[i]}",`;
  }
  const graphQuery = `
    {nodes(ids: [${productIds}]){
        ... on Product {
            id
            title
            description
            onlineStoreUrl
            handle
            variants(first: 2){
              edges {
                  node {
                      id
                      availableForSale
                      price
                      compareAtPrice
                  }
              }
            }
            media(first: 1) {
                edges {
                    node {
                        mediaContentType
                        alt
                        ...on MediaImage {
                            image {
                                originalSrc
                                large: transformedSrc(maxWidth: 720)
                                small: transformedSrc(maxWidth: 360)
                            }
                        }
                    }
                }
            }
            tags
            priceRange {
            maxVariantPrice {
                amount
            }
            minVariantPrice {
                amount
            }
            }
            shortDescription: metafield(namespace: "p80", key: "shortDescription") {
              value
              type
            }
        }
        }
    }`;

  // Make sure we have products - if not, don't bother making our call
  if (!productIds) {
    return;
  }

  fetch('/api/2021-10/graphql.json', {
    method: 'POST',
    headers: {
      'X-Shopify-Storefront-Access-Token': this.config.storefrontToken,
      'Content-Type': 'application/graphql'
    },
    body: graphQuery
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.data) {
        history.productHistory = data.data.nodes;
        // Filter out null returns
        history.productHistory = history.productHistory.filter(function (el) {
          return el != null;
        });
        history.generate();
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
// Generate our markup
p80.productHistory.prototype.generate = function () {
  const history = this;
  const glideComponent = this.createWrapper();
  const wrapper = document.createElement('div');
  wrapper.classList.add('product-history');

  const title = document.createElement('h2');
  title.classList.add('product-history__title');
  title.textContent = history.config.title;
  wrapper.appendChild(title);

  const glideCount = glideComponent.querySelector('#slide-count-text');
  if (glideCount) {
    glideCount.textContent = `/${history.productHistory.length}`;
  }

  const productsWrapper = glideComponent.querySelector('.glide__slides');
  productsWrapper.classList.add('product-history__wrapper');

  const productCardTemplate = document.getElementById('product-card-template');
  if (!productCardTemplate) return;

  // Loop through our history products
  for (var i = 0; i < history.productHistory.length; i++) {
    // Create our wrapper link
    const product = productCardTemplate.content.cloneNode(true);
    const productLink = product.querySelector('.product-link');
    productLink.setAttribute('title', history.productHistory[i].title);
    productLink.href = `/products/${history.productHistory[i].handle}`;
    productLink.textContent = history.productHistory[i].title;

    // Create our product image if it exists
    let productImage = product.querySelector('.product-image');
    if (history.productHistory[i].media.edges.length > 0) {
      const imageUrls = history.productHistory[i].media.edges[0].node.image;
      let srcSet = '';
      let imageSizes = '';
      let originalSrc = '';
      for (const url in imageUrls) {
        if (url === 'small') {
          srcSet += `${imageUrls[url]} 360w,`;
          imageSizes += '(max-width: 767px) 360px, ';
        } else if (url === 'large') {
          srcSet += `${imageUrls[url]} 720w,`;
          imageSizes += '(min-width: 768px) 720px, ';
        } else if (url === 'originalSrc') {
          originalSrc = imageUrls[url];
        }
      }
      productImage.setAttribute('loading', 'lazy');
      productImage.setAttribute('srcset', srcSet);
      productImage.setAttribute('sizes', imageSizes);
      productImage.src = originalSrc;
      productImage.alt = history.productHistory[i].title;
      productImage.classList.add('product-history__image');
    } else {
      productImage = document.createElement('div');
      productImage.classList.add('product-history__image--placeholder');
    }

    // Create our product text content
    const productDescription = product.querySelector('.product-description');
    if (productDescription) {
      //use shortdescription if available else use product description
      if (history.productHistory[i].shortDescription) {
        productDescription.textContent = history.productHistory[i].shortDescription.value;
      } else {
        let descriptionWordsArray = history.productHistory[i].description.split(' ');

        if (descriptionWordsArray.length > 17) {
          productDescription.textContent = `${descriptionWordsArray.slice(0, 18).join(' ')}...`;
        } else {
          productDescription.textContent = history.productHistory[i].description;
        }
      }
    }

    const productPrice = product.querySelector('.price');
    productPrice.classList.add('product-history__price');

    let minPrice = history.productHistory[i].priceRange.minVariantPrice.amount;
    let maxPrice = history.productHistory[i].priceRange.maxVariantPrice.amount;

    if (minPrice) {
      minPrice = parseFloat(minPrice).toFixed(2);
    }
    if (maxPrice) {
      maxPrice = parseFloat(maxPrice).toFixed(2);
    }

    let price = history.productHistory[i].variants.edges[0].node.price;
    let compareAtPrice = history.productHistory[i].variants.edges[0].node.compareAtPrice;
    if (price) {
      price = parseFloat(price).toFixed(2);
    }
    if (compareAtPrice) {
      compareAtPrice = parseFloat(compareAtPrice).toFixed(2);
    }
    // Display single price display
    if (price >= compareAtPrice || compareAtPrice === 0) {
      const regularPrice = productPrice.querySelector('.price__regular .price-item--regular');
      if (minPrice != maxPrice) {
        regularPrice.textContent = `From $${minPrice}`;
      } else {
        regularPrice.textContent = `$${minPrice}`;
      }
    }
    // Product has two different prices - show price range
    else {
      productPrice.classList.add('price--on-sale');

      const salePrice = productPrice.querySelector('.price__sale .price-item--sale');
      salePrice.classList.add('product-history__product-sale');

      const originalPrice = productPrice.querySelector('.price__sale .price-item--regular');
      originalPrice.classList.add('product-history__product-original');
      salePrice.textContent = `$ ${price} - `;
      originalPrice.textContent = `$ ${compareAtPrice}`;
    }
    //set badges
    const badgeElement = product.querySelector('.badges');
    this.setBadges(history.productHistory[i], badgeElement);

    //add quick add button or quick view
    const quickAdd = product.querySelector('.quick-add');
    if (history.productHistory[i].variants.edges.length === 1) {
      //generate quick a2c button
      const quickA2C = this.generateQuickAddToCart(history.productHistory[i]);
      quickAdd.appendChild(quickA2C);
    } else {
      const quickViewModal = this.generateQuickViewModal(history.productHistory[i]);
      quickAdd.appendChild(quickViewModal);
    }

    // Append our product to the parent markup
    productsWrapper.appendChild(product);
  }
  // Append all products to our wrapper
  wrapper.appendChild(glideComponent);

  // Assign our markup to our object
  history.html = wrapper;

  history.appendMarkup();
};

/**
 * sets product badge
 * @param {product object} product
 * @param {html element container} badgeElement
 */
p80.productHistory.prototype.setBadges = function (product, badgeElement) {
  let firstVariant = product.variants.edges[0].node;
  let price = firstVariant.price;
  let compareAtPrice = firstVariant.compareAtPrice;
  if (!badgeElement) return;

  if (!firstVariant.availableForSale) {
    badgeElement.classList.add('product--out-of-stock');
  } else {
    if (compareAtPrice > 0 && price < compareAtPrice) {
      badgeElement.classList.add('product--on-sale');
    } else if (product.tags.includes('new')) {
      badgeElement.classList.add('product--new');
    }
  }
};

//create quick view modal
/**
 *
 * @param {product object} product
 * @returns returns modal opener and quick add modal for product quick view
 */
p80.productHistory.prototype.generateQuickViewModal = function (product) {
  //get quick view template
  const quickViewTemplate = document.getElementById('quick-view-template');
  if (!quickViewTemplate) return;

  const productId = product.id.split('/').pop();
  //clone quickview template
  const quickView = quickViewTemplate.content.cloneNode(true);

  //set modal opener target modal id
  const modalOpener = quickView.querySelector('modal-opener');
  if (!modalOpener) return;
  modalOpener.dataset.modal = `#QuickAdd-${productId}`;

  //set modal opener button id and data-product-url attributes
  const modalOpenerButton = modalOpener.querySelector('button');
  if (!modalOpenerButton) return;
  modalOpenerButton.setAttribute('id', `${modalOpenerButton.getAttribute('id')}-${productId}-submit`);
  modalOpenerButton.dataset.productUrl = `/products/${product.handle}`;

  //set quick add modal id
  const quickAddModal = quickView.querySelector('quick-add-modal');
  quickAddModal.setAttribute('id', `QuickAdd-${productId}`);

  //set modal close button id
  const closeButton = quickAddModal.querySelector('button.quick-add-modal__toggle');
  if (!closeButton) return;
  closeButton.setAttribute('id', `ModalClose-${productId}`);

  //set modal dialog aria label attribute
  const dialog = quickView.querySelector('.quick-add-modal__content');
  if (!dialog) return;
  dialog.setAttribute('aria-label', `${dialog.getAttribute('aria-label')} ${product.title}`);

  //set content info id attribute
  const contentInfo = quickView.querySelector('.quick-add-modal__content-info');
  if (!contentInfo) return;
  contentInfo.setAttribute('id', `QuickAddInfo-${productId}`);

  return quickView;
};

/**
 * create quick add to cart button
 * @param {product object} product
 * @returns product-form component for quick add to cart
 */
p80.productHistory.prototype.generateQuickAddToCart = function (product) {
  const quickAddToCartTemplate = document.getElementById('quick-add-to-cart-template');
  if (!quickAddToCartTemplate) return;

  const productId = product.id.split('/').pop();
  const defaultVariant = product.variants.edges[0].node;
  const quickAddToCartForm = quickAddToCartTemplate.content.cloneNode(true);

  //set form attributes
  const productForm = quickAddToCartForm.querySelector('form');
  if (!productForm) return;
  productForm.setAttribute('id', `${productForm.getAttribute('id')}-${productId}`);

  //set input[name="id"] value
  const idInput = quickAddToCartForm.querySelector('input[name="id"]');
  if (!idInput) return;
  idInput.value = defaultVariant.id.split('/').pop();

  //set submit button id
  const submitButton = quickAddToCartForm.querySelector('[type="submit"]');
  if (!submitButton) return;
  submitButton.setAttribute('id', `${submitButton.getAttribute('id')}-${productId}`);

  //disabled button if variant unavailable
  if (!defaultVariant.availableForSale) {
    submitButton.setAttribute('disabled', '');
    return quickAddToCartForm;
  }
  return quickAddToCartForm;
};

// create products wrapper
/**
 * @returns a glide component
 */
p80.productHistory.prototype.createWrapper = function () {
  const glideTemplate = document.getElementById('glide-template');
  return glideTemplate.content.cloneNode(1);
};

// Add our markup to the page
p80.productHistory.prototype.appendMarkup = function () {
  const target = this.findTargetElement();
  if (target) {
    target.innerHTML = '';
    target.appendChild(this.html);
  } else {
    console.error(`Unable to find the element identified by ${this.targetElement}`);
  }
};
// Helper function to find our target element for appending markup
p80.productHistory.prototype.findTargetElement = function () {
  /****
   *
   * Target Finding priority:
   *
   * ID
   * Class - Taking first result
   * Data Attributes - Taking first result
   *
   */

  // Find by ID
  let target = document.getElementById(this.config.targetElement);
  // Find by Class
  if (!target) {
    target = document.getElementsByClassName(this.config.targetElement);
    if (target) {
      target = target[0];
    }
  }
  // Find by Attribute
  if (!target) {
    target = document.querySelector(`[${this.config.targetElement}]`);
  }

  // Return our target if found
  return target ? target : null;
};
// Push a product view into our history cookie
p80.productHistory.prototype.addProductView = function () {
  const history = this;
  // We only update our history if we were passed the current product ID
  if (!history.config.productId) {
    return;
  }
  const cookies = document.cookie;
  let cookie = cookies.match(new RegExp('(^| )' + history.config.cookieName + '=([^;]+)'));
  // We have previous history data
  if (cookie && cookie.length > 1) {
    cookie = cookie[2];
    cookie = JSON.parse(cookie);

    // Check if the product already exists in our cookie, remove it if found
    const cookieKey = cookie.indexOf(history.config.productId);
    if (cookieKey > -1) {
      cookie.splice(cookieKey, 1);
    }

    // Add our new product to the front of the array
    cookie.unshift(history.config.productId);
    // If our array is longer than our maximum stored results, delete the last result
    if (cookie.length > history.config.resultsStored) {
      cookie.pop();
    }
    cookie = JSON.stringify(cookie);
    document.cookie = `${history.config.cookieName}=${cookie}; expires=${new Date(
      new Date().getTime() + 1000 * 60 * 60 * 24 * 365
    ).toGMTString()}; path=/`;
  }
  // Wow, no history! Let's initalize a new cookie
  else {
    cookie = [history.config.productId];
    cookie = JSON.stringify(cookie);
    document.cookie = `${history.config.cookieName}=${cookie}; expires=${new Date(
      new Date().getTime() + 1000 * 60 * 60 * 24 * 365
    ).toGMTString()}; path=/`;
  }
};
